import type { MortgageData } from '@/components/calculator/CalculatorTabs';
import { CalculatorReportState } from '@/types/reportTypes';
import { formatUserName, getUserEmail } from '@/utils/userProfileUtils';

export const transformMortgageDataToCalculatorReport = (
  mortgageData: MortgageData,
  user?: any
): CalculatorReportState => {
  const loanAmount = mortgageData.homePrice - mortgageData.downPayment;

  return {
    reportData: {
      mortgageSummary: {
        homePrice: mortgageData.homePrice,
        loanAmount,
        downPayment: mortgageData.downPayment,
        interestRate: mortgageData.interestRate,
        loanTerm: mortgageData.loanTerm,
        loanType: mortgageData.loanType,
      },
      monthlyPayment: {
        principal: mortgageData.monthlyPayment.principal,
        interest: mortgageData.monthlyPayment.interest,
        taxes: mortgageData.monthlyPayment.taxes,
        insurance: mortgageData.monthlyPayment.insurance,
        pmi: mortgageData.monthlyPayment.pmi,
        hoa: mortgageData.monthlyPayment.hoa,
        total: mortgageData.monthlyPayment.total,
      },
      closingCosts: {
        loanOrigination: mortgageData.closingCosts.loanOrigination,
        appraisalFee: mortgageData.closingCosts.appraisalFee,
        titleServices: mortgageData.closingCosts.titleServices,
        governmentRecordingCharges: mortgageData.closingCosts.governmentRecordingCharges,
        prepaids: mortgageData.closingCosts.prepaids,
        initialEscrow: mortgageData.closingCosts.initialEscrow,
        other: mortgageData.closingCosts.other,
        fundingFee: mortgageData.closingCosts.fundingFee || 0,
        sellerCreditAmount: mortgageData.closingCosts.sellerCreditAmount || 0,
        total: mortgageData.closingCosts.total,
      },
      location: {
        state: mortgageData.location?.state || '',
        city: mortgageData.location?.city || '',
      },
      propertyType: mortgageData.propertyType || 'Single Family',
      isFirstTimeHomebuyer: mortgageData.isFirstTimeHomebuyer || false,
      creditScore: mortgageData.creditScore || 700,
    },
    metadata: {
      generatedAt: new Date().toISOString(),
      reportId: `calc-${Date.now()}`,
      userId: user?.id,
    },
  };
};
